/**
 * getListFn: 页面列表接口（传入方法 “引用”）
 * searchData: 页面列表搜索参数
 * exportTemplate: 导出模板参数
 * otherFn: searchHandle所需要调用的其他方法（传入方法 “名字”）
 */
export default ({
  getListFn,
  exportTemplate,
  otherFn,
}) => {
  return {
    data() {
      return {
        exportParams: {}, // 导出参数
        tableData: [], // 表格数据
        paginationData: { // 分页
          pageNum: 1,
          pageSize: 10,
          total: 0,
          pageSizes: [10, 20, 30, 50],
        },
        oLoading: {
          search: false, // 搜索
          exportByColumn: false, // 表格列上的导出
        },
        exportTemplate, // 导出模板
        formName: 'search', // 表单ref TODO: 先写死
      }
    },
    mounted() {
      this.searchHandle()
    },
    methods: {
      // 搜索事件
      searchHandle() {
        // 考虑带验证和不带验证的情况
        if (this.$refs[this.formName]) {
          this.$refs[this.formName].validate((valid) => {
            if (valid) {
              this.searchFn()
            }
          })
          return
        }
        this.searchFn()
      },
      searchFn() {
        otherFn && this[otherFn]()
        this.paginationData.pageNum = 1
        this.paginationChange({
          pagination: this.paginationData,
        })
      },
      // 切换页码
      paginationChange(payload) {
        const { pagination } = payload
        this.paginationData.pageSize = pagination.pageSize
        this.paginationData.pageNum = pagination.pageNum
        this.getList()
      },
      // 获取表格列表数据
      async getList() {
        this.oLoading.search = true
        try {
          const params = {
            taskType: this.taskType,
            pageSize: this.paginationData.pageSize,
            pageNum: this.paginationData.pageNum,
          }

          this.exportParams = Object.assign({}, params)

          const { code, data } = await getListFn.call(this, params)
          this.oLoading.search = false
          if (code === 1) {
            this.tableData = (data && data.items) || []
            this.paginationData.total = data.totalNum
          }
        } catch (error) {
          this.oLoading.search = false
        }
      },
    },
  }
}
